import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';
@Component({
    selector: 'app-revert-corp-addon-dialog',
    templateUrl: './revert-corp-addon-dialog.component.html',
    styleUrls: ['./revert-corp-addon-dialog.component.css']
})
export class RevertCorpAddonDialogComponent implements OnInit {
    licenseDetails: any;
    api_error: any;
    api_success: string;
    revert;
    addoncorplicense;
    acclicid;
    corpLicenseId;
    type: string;
    disableConfirmbtn = false;
    constructor(
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: number,
        private corporateService: CorporateService) { }
    ngOnInit() {
        this.addoncorplicense = this.data['addoncorplicense'];
        this.revert = this.addoncorplicense.downgradTo;
    }
    public closeDialog() {
        this.dialogRef.close();
    }
    onConfirm() {
        this.api_error = '';
        this.disableConfirmbtn = true;
        this.corpLicenseId = this.addoncorplicense.corpLicenseId;
        this.corporateService.revert(this.corpLicenseId, this.data['corpId'])
            .subscribe(
                data => {
                    if (this.revert === 0) {
                        this.disableConfirmbtn = true;
                        this.api_success = 'Revert Successfully';
                    } else {
                        if (this.type === 'addons') {
                            this.disableConfirmbtn = true;
                            this.api_success = 'Revert Successfully';
                        } else {
                            this.disableConfirmbtn = true;
                            this.api_success = 'Revert Successfully';
                        }
                    }
                    setTimeout(() => {
                        this.dialogRef.close('reloadlist');
                    }, 2000);
                },
                (error) => {
                    this.disableConfirmbtn = false;
                    this.api_error = error.error;
                }
            );
    }
}
